import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Event } from 'services/@types';
import EventService from 'services/event.api';

export interface EventState {
  events: Event[];
  event: Event | null;
  loading: boolean;
  error: string | null;
  pagination: {
    page: number;
    limit: number;
    totalPages: number;
    totalResults: number;
  };
}

const initialState: EventState = {
  events: [],
  event: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 1,
    totalResults: 0,
  },
};

export const fetchEvents = createAsyncThunk(
  'event/fetchAll',
  async (params: Record<string, any>, { rejectWithValue }) => {
    try {
      return await EventService.getEvents(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.events = action.payload.results;
        state.pagination = {
          page: action.payload.page,
          limit: action.payload.limit,
          totalPages: action.payload.totalPages,
          totalResults: action.payload.totalResults,
        };
      })
      .addCase(fetchEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default eventSlice.reducer;
